import { routes } from '../../constants';
import image500 from '../../images/errorPages/500.svg';
import { ResetErrorLink } from '../layouts/ResetErrorLink';

export const Internal = () => {
    return (
        <div className="container-error">
            <div className="content-error">
                <div className="error-type-block">
                    <img src={image500} width="530" height="300" alt="500" />
                </div>
                <h1>Error: Unexpected Error</h1>
                <p className="error-description">
                    Oops... Something went wrong at our end. We've been notified and fixing the issue.
                </p>
                <p className="error-links">
                    Either check the URL, <ResetErrorLink to={routes.root}>go home</ResetErrorLink>, or feel free to <a href={`mailto:${process.env.REACT_APP_SALES_EMAIL}`}>report the issue</a>.
                </p>
            </div>
        </div>
    );
}